import { Route, Navigate, Routes } from "react-router-dom";
import EditProduct from "./Pages/ProductPage/EditProduct/EditProduct.js"
import ProductsList from "./Pages/ProductPage/ProductList/ProductList.js"
import AddProduct from "./Pages/ProductPage/AddProduct/AddProduct.js"
import DiscountList from "./Pages/DiscountCode/DiscountList/DiscountList.js";
import AddDiscount from "./Pages/DiscountCode/AddDiscount/AddDiscount.js";

function DiscountRoutes({ token }) {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={token ? <DiscountList /> : <Navigate to="/" />}
        />
        <Route
          path="/edit/:id"
          element={token ? <AddDiscount /> : <Navigate to="/" />}
        />
        <Route
          path="/add/"
          element={token ? <AddDiscount /> : <Navigate to="/" />}
        />
      </Routes>
    </>
  )
}


export default DiscountRoutes;